// month-grid-core.js — logica PURA del componente condiviso MonthGrid (A3,
// ondata 30): la griglia mensile del design system (client/src/ui/).
// File PURO (niente JSX, niente DOM): è QUESTO che il contract test
// server/src/lib/month-grid.test.js esercita sotto node --test — il JSX
// (MonthGrid.jsx) resta un guscio di resa che DELEGA qui ogni decisione.
//
// Le formule replicano ESATTAMENTE la matematica del calendario v1
// (admin-module.js renderCalendario r.1519-1545): settimana lunedì-prima,
// griglia fissa di 42 celle (6 settimane), flag out-of-month e today.
// Il test le pinna anche STATICAMENTE sul sorgente v1 (drift ⇒ ROSSO).
//
// Primo consumatore reale: CalendarioView.jsx (amm-v3). Secondo consumatore
// potenziale censito: il calendario del Cruscotto dash (dashboard-module.js
// renderCalendar) in una futura ondata dash-v3.

// data → 'YYYY-MM-DD' (replica iso() v1 r.1524 — MAI toISOString: niente UTC,
// il calendario ragiona in ora locale come il v1)
export function isoOf(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

// finestra della griglia per (anno, mese 0-based): start = lunedì della
// settimana del 1°, last = start+41 — sono ANCHE gli estremi {da, a} del
// fetch delle scadenze nel v1 (r.1526)
export function calMeta(y, m) {
  const first = new Date(y, m, 1);
  const startDow = (first.getDay() + 6) % 7; // lunedì-prima (r.1522)
  const start = new Date(y, m, 1 - startDow);
  const last = new Date(start);
  last.setDate(start.getDate() + 41);
  return { start, last, da: isoOf(start), a: isoOf(last) };
}

// le 42 celle della griglia: {iso, day, out, today}. todayIso per parametro
// (testabilità: il chiamante passa AMM.isoToday() o l'oggi reale)
export function buildCells(y, m, todayIso) {
  const { start } = calMeta(y, m);
  const cells = [];
  for (let i = 0; i < 42; i++) {
    const cur = new Date(start);
    cur.setDate(start.getDate() + i);
    const iso = isoOf(cur);
    cells.push({ iso, day: cur.getDate(), out: cur.getMonth() !== m, today: iso === todayIso });
  }
  return cells;
}

// scadenze → mappa giorno → righe (replica byDay v1 r.1531-1532; ordine di
// lista conservato dentro il giorno)
export function groupByDay(rows) {
  const byDay = {};
  (rows || []).forEach((s) => {
    (byDay[s.data_scadenza] = byDay[s.data_scadenza] || []).push(s);
  });
  return byDay;
}

// navigazione mese prev/next con wrap di anno (replica r.1558-1559)
export function shiftMonth(cal, delta) {
  let m = cal.m + delta;
  let y = cal.y;
  if (m < 0) { m = 11; y -= 1; }
  if (m > 11) { m = 0; y += 1; }
  return { y, m };
}

// Stato da mostrare — stessa precedenza DICHIARATA di selectTableState
// (data-table-core): dati presenti ⇒ 'data' SEMPRE (il reload in corso o
// fallito NON svuota la griglia: il chiamante comunica l'errore col suo
// banner); senza dati: error › loading › 'data' (la griglia vuota È lo stato
// data: un mese senza eventi mostra comunque le 42 celle, parità v1).
export function selectMonthGridState(s) {
  if (s && s.hasData) return 'data';
  if (s && s.error) return 'error';
  if (s && s.loading) return 'loading';
  return 'data';
}
